<template>
  <BaseModal modalColor="border-warning bg-warning" iconModal="fa fa-edit" subtitulo="Alterar senha do usuário"
             col-md="col-md-3" offset="3">
    <template v-slot:modalContent>
      <form @submit.prevent="submitResetForm">
        <div class="form-group">
          <FloatLabel variant="on">
            <Password inputId="senha1" v-model="senha1" toggleMask autofocus fluid
                      :inputProps="{ autocomplete: 'new-password' }"/>
            <label for="senha1"><strong>Senha: </strong></label>
          </FloatLabel>
        </div>
        <div class="form-group">
          <FloatLabel variant="on">
            <Password inputId="senha2" v-model="senha2" toggleMask fluid
                      :inputProps="{ autocomplete: 'new-password' }"/>
            <label for="senha2"><strong>Confirmação da senha: </strong></label>
          </FloatLabel>
        </div>
        <div class="ibox-footer">
          <div class="float-right">
            <button type="submit" class="btn btn-primary font-bold">Confirmar</button>
          </div>
          <button class="btn btn-danger font-bold" @click="fechar">
            Cancelar
          </button>
        </div>
      </form>
    </template>
  </BaseModal>
</template>

<script>
import BaseModal from '@/components/base/BaseModal.vue';
import {apiUrl} from "@/router/apiBackRoutes";


export default {
  name: "AlterarSenha",
  components: {
    BaseModal,
  },
  emits: ["fechar"],
  props: {
    usuarioId: Number
  },
  data() {
    return {
      senha1: "",
      senha2: "",
      mediumRegex: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{6,}$/,
      strongRegex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/
    }
  },
  methods: {
    fechar() {
      this.$emit("fechar");
    },
    async submitResetForm() {
      try {
        const response = await fetch(apiUrl.usuarios.reset(this.usuarioId), {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          credentials: 'include',
          body: JSON.stringify({
            senha1: this.senha1,
            senha2: this.senha2
          })
        });

        if (!response.ok) {
          const errorData = await response.json();
          console.log(errorData)
          this.$toastMessage("warn", "Atenção", errorData.detail);
        } else {
          this.$toastMessage("success", "Senha alterada com sucesso!");
          this.fechar();
        }
      } catch (error) {
        this.$toastMessage("warn", "Atenção", "Erro!");

      }

    },
  },
}
</script>

<style scoped>
:deep(.p-password-mask),
:deep(.p-password-toggle-mask),
:deep(.p-password-toggle-mask-icon) {
  z-index: 99 !important;
  color: #333 !important;
}
</style>